<template>
  <div>
    <b-card
      class="border-0 p-0"
      :class="{
        'fixed-bottom wrapper': isMobileScreen,
        'hiding-popup': shouldHideOnMobile
      }"
    >
      <b-card-img
        :src="
          categoryModal.imageUrl || require(`../../assets/images/popup.webp`)
        "
        alt="India's Export Data"
        top
        class="border-0 d-none d-sm-block max-img-height"
      ></b-card-img>
      <b-card-body class="p-4">
        <div class="card-heading">
          {{
            categoryModal.title || 'Get Fast Access to Cash without Collateral'
          }}
        </div>
        <b-card-text class="sub-text">
          {{
            categoryModal.description ||
            'Instant Disbursal | High Credit Limit | Lowest Rates | Paperless | Transparent'
          }}
        </b-card-text>
        <b-button @click="hideModal" variant="outline-primary">
          Not Now
        </b-button>
        <b-button
          href="https://www.dripcapital.com/en-in/exporters/apply"
          @click="hideModal"
          variant="primary"
          class="ml-3"
        >
          Get Quote
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shouldHideOnMobile: false,
      categoryModal: {}
    }
  },
  props: ['isMobileScreen'],
  methods: {
    hideModal: function () {
      this.isMobileScreen
        ? (this.shouldHideOnMobile = true)
        : this.$emit('hideModal')
    }
  },
  mounted() {
    const images = [
      `${process.env.BASE_URL}modalImages/automotivePartsAutomotive.webp`,
      `${process.env.BASE_URL}modalImages/clothing.webp`,
      `${process.env.BASE_URL}modalImages/constructionMaterials.webp`,
      `${process.env.BASE_URL}modalImages/electronics.webp`,
      `${process.env.BASE_URL}modalImages/ironSteelArticles.webp`,
      `${process.env.BASE_URL}modalImages/machinery.webp`,
      `${process.env.BASE_URL}modalImages/plasticProducts.webp`,
      `${process.env.BASE_URL}modalImages/printsStationery.webp`,
      `${process.env.BASE_URL}modalImages/woodFurnitureFittings.webp`
    ]
    for (let i = 0; i < images.length; i++) {
      let l = document.createElement('link')
      l.rel = 'preload'
      l.as = 'image'
      l.href = images[i]
      document.head.appendChild(l)
    }

    if (['searchResults', 'hsCode'].includes(this.$route.name)) {
      const urls = this.$store.state.app.hsnUrls
      const categories = this.$store.state.app.modalCategories
      const matchingObject = urls.find((u) => {
        return (
          u.url.toLowerCase().indexOf(this.$route.fullPath.toLowerCase()) > -1
        )
      })

      if (matchingObject) {
        const matchedCategory = categories.find(
          (c) => c.title && c.category === matchingObject.category
        )
        if (matchedCategory) {
          this.categoryModal = {
            ...matchedCategory,
            imageUrl: `${process.env.BASE_URL}modalImages/${matchedCategory.imageUrl}`
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-heading {
  font-size: 1.8rem;
  color: $secondary;
  font-weight: bold;
  margin-bottom: 10px;
}

.card-body {
  padding: 0;
}

.wrapper {
  width: 100vw;
  background: #fff;
  padding: 20px;
  text-align: center;
}

.hiding-popup {
  height: 0;
}

.sub-text {
  color: $grey-sub-text;
}
</style>
